import { render, staticRenderFns } from "./ImageWidget.vue?vue&type=template&id=6cd2a64e&scoped=true"
import script from "./ImageWidget.vue?vue&type=script&lang=js"
export * from "./ImageWidget.vue?vue&type=script&lang=js"
import style0 from "./ImageWidget.vue?vue&type=style&index=0&id=6cd2a64e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd2a64e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cd2a64e')) {
      api.createRecord('6cd2a64e', component.options)
    } else {
      api.reload('6cd2a64e', component.options)
    }
    module.hot.accept("./ImageWidget.vue?vue&type=template&id=6cd2a64e&scoped=true", function () {
      api.rerender('6cd2a64e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/viewer/templateWidgets/ImageWidget.vue"
export default component.exports